<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          挫折忍耐度
          <span class="en-text">Frustration tolerance</span>
        </span>
      </div>
      <div class="field-value">
        <el-select
          class="w-100"
          placeholder="請選擇"
          v-model="activity.FrustrationTolerance"
        >
          <el-option label="高 (High)" :value="0" />
          <el-option label="中 (Medium)" :value="1" />
          <el-option label="低 (Low)" :value="2" />
        </el-select>
      </div>
    </div>

    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          具體事蹟
          <span class="en-text">Specific records</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="activity.ExtracurricularActivities"
        />
      </div>
    </div>

    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          社團/興趣
          <span class="en-text">Community/hobbies</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="activity.Interest"
        />
      </div>
    </div>
    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          優良事蹟
          <span class="en-text">Excellence records</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="activity.OutstandingPerformance"
        />
      </div>
    </div>

    <div class="edit-btn-wrap">
      <!-- 儲存 -->
      <button type="button" class="put-btn" @click="saveActivity">
        {{ $t("BUTTON.RESUME_SAVE") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLActivities",

  data() {
    return {
      activity: {},

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 活動經驗
    saveActivity() {
      this.$api.idl
        .putActivity(this.source, {
          ...this.activity,
          UserId: this.source === 'resume' ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "活動經驗儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === 'resume') {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getActivity();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 活動經驗
    getActivity() {
      const candidate = this.source === "resume" ? this.$cookies.get("candidateId") : this.matchId;
      this.updateLoading(true);
      this.$api.idl
        .getActivity(this.source, candidate)
        .then((response) => {
          if (response.status === 200) {
            this.activity = response.data;
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getActivity();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
